async function send(toEmail, subject, body){
  let data = {
    'Message': {
      'Subject': subject,
      'Body': {
        'ContentType': 'HTML',
        'Content': body,
      },
      'ToRecipients': [
        {
          'EmailAddress': {
            'Address': toEmail,
          },
        },
      ],
    },
    'SaveToSentItems': true
  };
  let resp = await fetch('https://graph.microsoft.com/v1.0/me/sendMail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.access_token,
    },
    body: JSON.stringify(data)
  });
  return 'OK';
}

export default {
  send,
};
